function logError(key: string) {
    const error = localStorage.getItem(key);
    error && console.error(error);
    localStorage.removeItem(key);
}
// 需要加载完成后将localStorage里的报错上报
try {
    logError(`${(window as any).WIKI_ASSETS_RETRY_ERROR}`);
    logError(`${(window as any).WIKI_ASSETS_RETRY_If}`);
} catch (e) {
    console.error(e);
}

export default (e: any, fuc: any, param: any) => {
    try {
        if (e && e.message) {
            const paramString = param.toString();
            let paramInfo = paramString;
            if (paramString === '[object Object]') {
                paramInfo = `${paramString} ${JSON.stringify(param)}`;
            }
            e.message = `${e.message} params: ${paramInfo} function: ${fuc.toString()}`;
        }
        return e;
    } catch (e) {
        console.error(e);
    }
};
